import { Activity } from '@/types';
import { roundNumber } from './maths';

/**
 *
 * @param activity
 * @returns Training Stress Score (TSS) for an activity
 */
export const getTSS = (
  activity: Pick<Activity, 'suffer_score' | 'moving_time'>
) => {
  const { suffer_score, moving_time } = activity;
  if (!suffer_score) return null;
  return roundNumber((suffer_score * moving_time) / (60 * 60 * 100));
};

export const getIntensityFactor = (activity: Activity, FTP: number) => {
  const { average_watts } = activity;
  if (!FTP || !average_watts) return null;
  return roundNumber(average_watts / FTP);
};
